<template>
  <div>
    <b-card>
      <div class="d-flex flex-wrap align-items-center">
        <div class="title mr-auto">
          보안 정책
        </div>
      </div>
      <hr>
      <b-row class="mb-2">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_lock_count" v-b-tooltip.hover title="로그인 시도는 최대 5번이에요.">
            비밀번호 틀린 횟수
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12">
          <b-input class="mt-1" type="number" v-model="group.security_policy.account_lock_count" :disabled="lock || true" plaintext></b-input>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_lock_time"  v-b-tooltip.hover title="로그인 실패 횟수가 많으면 5분동안 로그인을 하지못해요.">
            차단 시간(분)
          </label>
        </b-col>
        <b-col class="col-xl-3 col-md-12">
          <b-input class="mt-1" type="number" v-model="group.security_policy.account_lock_time" :disabled="lock || true" plaintext></b-input>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_password_min_len">
            비밀번호 최소 길이
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12">
          <b-input class="mt-1" type="number" v-model="group.security_policy.password_min_len" :disabled="lock || true" plaintext></b-input>
        </b-col>
      </b-row>
      <br>
      <b-row class="mb-2">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" label-for="ph_password_use_alphabet" v-b-tooltip.hover title="비밀번호 설정시 알파벳을 허용해요, ex) abcdef....">
            비밀번호 알파벳 허용
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox disabled" name="Alphabet" id="Alphabet" v-model="group.security_policy.password_use_alphabet" :disabled="lock || true">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" label-for="ph_password_use_number" v-b-tooltip.hover title="비밀번호 설정시 특수 문자를 허용해요, ex) !@#$%&*()_+-=">
            비밀번호 특수 문자 허용
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
          <div class="checkbox-switch disabled">
            <input type="checkbox" class="input-checkbox disabled" name="Spacial" id="Spacial" v-model="group.security_policy.password_use_number" :disabled="lock || true">
            <div class="checkbox-animate">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" label-for="ph_password_use_spacial" v-b-tooltip.hover title="비밀번호 설정시 숫자를 허용해요, ex) 0123456789">
            비밀번호 숫자 허용
          </label>
        </b-col>
        <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
          <div class="checkbox-switch">
            <input type="checkbox" class="input-checkbox disabled" name="Number" id="Number" v-model="group.security_policy.password_use_spacial" :disabled="lock || true">
            <div class="checkbox-animate disabled">
              <span class="checkbox-off">OFF</span>
              <span class="checkbox-on">ON</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <hr>
      <b-row class="mb-2">
        <b-col class="col-xl-12 col-md-12 d-flex align-self-center">
          <h5 class="text-danger strong">* IP 허용 : 그룹의 설정이 그룹의 모든 계정에 적용됩니다.</h5>
        </b-col>
      </b-row>
        <ip-list
          type="계정"
          comment="그룹의 IP 액세스 제어 정책이 먼저 나오고 사용자별 IP 액세스 제어 정책이 옵니다."
          :lock="lock || true"
          :press="false"
          :show_button="false"
          :ip_list="group.allow_ip_account || []"
          :edit="false"
          >
          <!-- @add="ip_add"
          @save="save"
          @remove="ip_remove"
          @clear="ip_clear" -->
        </ip-list>
        <ip-list
          type="에이전트"
          comment="IP 접근 제어는 에이전트 설치 시 적용됩니다. 에이전트가 없으면 아무데나 설치할 수 있지만 권장합니다."
          :lock="lock || true"
          :press="false"
          :show_button="false"
          :edit="false"
          :ip_list="group.allow_ip_agent || []"
          >
        </ip-list>
        <!-- @add="ip_add"
        @save="save"
        @remove="ip_remove"
        @clear="ip_clear" -->
      <!-- <template v-if="lock">
        <template>
          <b-button size="sm" variant="primary" @click="edit"> Modify </b-button>
        </template>
      </template>
      <template v-else>
        <b-button size="sm" variant="success" @click="save"> Save </b-button>
        <b-button size="sm" variant="default" @click="cancel"> Cancel </b-button>
      </template> -->
    </b-card>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>